/**
 * Older listings store HSN as a number, which drops leading zeros (0052 → 52).
 * Restore them to the next valid length (4, 6, or 8). A code that already has
 * that length is returned unchanged, including zeros typed at the front.
 */
export function formatHsnForDisplay(hsn) {
  const raw = String(hsn ?? "").trim();
  if (!/^\d+$/.test(raw)) return raw;
  if (raw.length === 4 || raw.length === 6 || raw.length === 8) return raw;
  const target = raw.length < 4 ? 4 : raw.length < 6 ? 6 : 8;
  return raw.padStart(target, "0");
}
